
import React from 'react';
import logoImage from '@/assets/greenvision-logo.png';

interface LogoProps {
  className?: string;
}

export const Logo = ({ className = "h-8 object-contain" }: LogoProps) => {
  return (
    <img 
      src={logoImage}
      alt="Greenvision Energy" 
      className={className}
      loading="eager"
      decoding="async"
    />
  );
};
